import { PlaneGeometry, RawShaderMaterial, AdditiveBlending, Vector2, Mesh } from "three";

import mouse_vert from "./glsl/sim/mouse.vert";
import externalForce_frag from "./glsl/sim/externalForce.frag";
import ShaderPass from "./ShaderPass";
import Input from "../Utils/Input";

export default class ExternalForce extends ShaderPass{
    constructor(simProps){
        super({
            output: simProps.dst
        });
        this.input = Input.getInstance()
        this.init(simProps);
    }

    init(simProps){
        super.init();
        const mouseG = new PlaneGeometry(
            1, 1
        );

        const mouseM = new RawShaderMaterial({
            vertexShader: mouse_vert,
            fragmentShader: externalForce_frag,
            blending: AdditiveBlending,
            depthWrite: false,
            depthTest: false,
            uniforms: {
                px: {
                    value: simProps.cellScale
                },
                force: {
                    value: new Vector2(0.0, 0.0)
                },
                center: {
                    value: new Vector2(0.0, 0.0)
                },
                scale: {
                    value: new Vector2(simProps.cursor_size, simProps.cursor_size)
                }
            },
        })

        this.mouseMesh = new Mesh(mouseG, mouseM);
        this.scene.add(this.mouseMesh);
    }

    update(props){
        const forceX = this.input.diff.x / 2 * props.mouse_force;
        const forceY = this.input.diff.y / 2 * props.mouse_force;

        const cursorSizeX = props.cursor_size * props.cellScale.x;
        const cursorSizeY = props.cursor_size * props.cellScale.y;

        const centerX = Math.min(Math.max(this.input.cursor.x, -1 + cursorSizeX + props.cellScale.x * 2), 1 - cursorSizeX - props.cellScale.x * 2);
        const centerY = Math.min(Math.max(this.input.cursor.y, -1 + cursorSizeY + props.cellScale.y * 2), 1 - cursorSizeY - props.cellScale.y * 2);

        const uniforms = this.mouseMesh.material.uniforms;

        uniforms.force.value.set(forceX, forceY);
        uniforms.center.value.set(centerX, centerY);
        uniforms.scale.value.set(props.cursor_size, props.cursor_size);

        super.update();
    }

    destroy() {
        super.destroy();
        this.scene.remove(this.mouseMesh);
        this.mouseMesh.geometry.dispose();
        this.mouseMesh.material.dispose();
        this.mouseMesh = null;
        this.input = null;
    }

}
